module.exports = __webpack_public_path__ + "static/media/yellowRing.bd101647.svg";